import React from "react";
import { Inbox } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export interface EmptyStateProps {
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
  secondaryActionLabel?: string;
  onSecondaryAction?: () => void;
  icon?: React.ReactNode;
  /** Render without the card frame, for use inside an existing panel. */
  bare?: boolean;
  className?: string;
}

export default function EmptyState({
  title,
  description,
  actionLabel,
  onAction,
  secondaryActionLabel,
  onSecondaryAction,
  icon,
  bare = false,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center px-6 py-12 text-center",
        !bare && "rounded-xl border border-dashed border-hairline-strong bg-card",
        className,
      )}
    >
      <div
        className="mb-4 flex size-12 items-center justify-center rounded-full bg-muted text-body [&_svg]:size-5"
        aria-hidden
      >
        {icon || <Inbox />}
      </div>
      <h3 className="text-base font-medium text-foreground">{title}</h3>
      <p className="mt-1 max-w-sm text-sm text-muted-foreground">{description}</p>
      {((actionLabel && onAction) || (secondaryActionLabel && onSecondaryAction)) && (
        <div className="mt-5 flex flex-wrap justify-center gap-2">
          {actionLabel && onAction && <Button onClick={onAction}>{actionLabel}</Button>}
          {secondaryActionLabel && onSecondaryAction && (
            <Button variant="outline" onClick={onSecondaryAction}>
              {secondaryActionLabel}
            </Button>
          )}
        </div>
      )}
    </div>
  );
}
